import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/stand.svg'
import _imports_1 from '@/assets/glass.svg'
import _imports_2 from '@/assets/ticket.svg'
import _imports_3 from '@/assets/ticket2.svg'
import _imports_4 from '@/assets/ticket3.svg'
import _imports_5 from '@/assets/side.svg'
import _imports_6 from '@/assets/ticketwin.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "http://www.grupotron-gs.com/grupotron/assets/images/logo_tron.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("h1", { style: {"margin":"0"} }, "Rifa de regalos Grupo Tron GS 2022")
], -1)
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "tombola" }
const _hoisted_4 = { class: "botones" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " Girar Tombola", -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Seleccionar Ganador", -1)
const _hoisted_9 = {
  id: "firstDrumHolder",
  class: "drumHolder fitImg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_11 = {
  class: "raffleHolder",
  style: {"opacity":"1"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_13 = { class: "drumMask" }
const _hoisted_14 = { class: "itemsWrapper" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"item shake3\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake2\"><img src=\"" + _imports_3 + "\"></div><div class=\"item shake3\"><img src=\"" + _imports_4 + "\"></div><div class=\"item shake2\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake\"><img src=\"" + _imports_3 + "\"></div>", 5)
const _hoisted_20 = [
  _hoisted_15
]
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"item shake2\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake\"><img src=\"" + _imports_3 + "\"></div><div class=\"item shake3\"><img src=\"" + _imports_4 + "\"></div><div class=\"item shake3\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake\"><img src=\"" + _imports_3 + "\"></div>", 5)
const _hoisted_26 = [
  _hoisted_21
]
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"item shake\"><img src=\"" + _imports_4 + "\"></div><div class=\"item shake2\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake\"><img src=\"" + _imports_3 + "\"></div><div class=\"item shake2\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake\"><img src=\"" + _imports_2 + "\"></div>", 5)
const _hoisted_32 = [
  _hoisted_27
]
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"item shake3\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake3\"><img src=\"" + _imports_3 + "\"></div><div class=\"item shake2\"><img src=\"" + _imports_4 + "\"></div><div class=\"item shake3\"><img src=\"" + _imports_2 + "\"></div><div class=\"item shake2\"><img src=\"" + _imports_4 + "\"></div>", 5)
const _hoisted_38 = [
  _hoisted_33
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "drumGlassHolder" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_40 = { class: "drumSideHolder" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "resultado" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 0,
  class: "winner h2"
}
const _hoisted_47 = {
  key: 1,
  class: "winner h1"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "ganadores" }

import { ref } from "vue";
import Confeti from "../components/Confeti.vue";
import Regalos from "../components/Regalos";
import Empleados from "../components/empleados";

export default /*#__PURE__*/_defineComponent({
  __name: 'Inicio',
  setup(__props) {

const nombres = Empleados;
const regalos = Regalos;

const ganador = ref({});
const girando = ref(false);
const winnerShow = ref(false);
const showPremio = ref(false);
const ganadores = ref([]);

const sorteo = () => {
  girando.value = false;
  if (regalos.length == 0) {
    alert("ya no hay regalos");
    return;
  }
  const randomNombre = Math.floor(Math.random() * nombres.length);
  const randomRegalo = Math.floor(Math.random() * regalos.length);
  ganador.value = {
    nombre: nombres[randomNombre],
    regalo: regalos[randomRegalo],
  };
  ganadores.value.push(ganador.value);
  nombres.splice(randomNombre, 1);
  regalos.splice(randomRegalo, 1);
  nombres.values = shuffle(nombres);
  regalos.values = shuffle(regalos);
  winnerShow.value = true;
  setTimeout(() => {
    showPremio.value = true;
  }, 5000);
};

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
}
const giro = () => {
  if (regalos.length == 0) {
    alert("ya no hay regalos");
    return;
  }
  girando.value = true;
  winnerShow.value = false;
  showPremio.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Confeti, { style: {"position":"fixed","top":"0","left":"0","z-index":"-1"} }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: giro,
            class: "btn",
            disabled: girando.value
          }, [
            _createVNode(_component_ion_icon, { name: "reload-outline" }),
            _hoisted_6
          ], 8, _hoisted_5),
          _createElementVNode("button", {
            onClick: sorteo,
            class: "btn",
            disabled: !girando.value
          }, [
            _createVNode(_component_ion_icon, { name: "trophy-outline" }),
            _hoisted_8
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: _normalizeClass(["items", { giro: girando.value, girost: !girando.value }])
                }, _hoisted_20, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["items", { giro2: girando.value, giro2st: !girando.value }])
                }, _hoisted_26, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["items", { giro3: girando.value, giro3st: !girando.value }])
                }, _hoisted_32, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["items", { giro4: girando.value, giro4st: !girando.value }])
                }, _hoisted_38, 2)
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", {
                  class: _normalizeClass(["side", { anim: girando.value, 'anim-stop': !girando.value }])
                }, _hoisted_42, 2)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", {
          class: _normalizeClass(["ticketRes", { show: winnerShow.value }])
        }, [
          _hoisted_44,
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (showPremio.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    (ganador.value.nombre.length > 25)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_46, _toDisplayString(ganador.value.nombre), 1))
                      : _createCommentVNode("", true),
                    (ganador.value.nombre.length <= 25)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_47, _toDisplayString(ganador.value.nombre), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (showPremio.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("h2", null, "#" + _toDisplayString(ganador.value.regalo.id) + " - " + _toDisplayString(ganador.value.regalo.nombre), 1),
                  _createElementVNode("img", {
                    src: require(`@/assets/regalos/${ganador.value.regalo.img}`),
                    style: {"height":"280px"}
                  }, null, 8, _hoisted_49)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ganadores.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "ganador",
          key: item.nombre
        }, [
          _createElementVNode("p", null, _toDisplayString(item.nombre), 1),
          _createElementVNode("p", null, _toDisplayString(item.regalo.nombre), 1)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})